<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 总部业务员管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			    @click="addHeadPerson('addHeadPersonForm')"
			>添加账号</el-button>
		</div>
        <div class="container">
			<p class="filtrate_flex">
				<el-form ref="filtrateform" :model="filtrateform" class="filtrate_form">
						<el-form-item label="姓名"  prop='name'>
							<el-input v-model="filtrateform.name" style="width:200px"></el-input>
						</el-form-item>
				</el-form>	
				<el-button class="filtrate_btn" type="primary" icon="el-icon-search" @click="filtrateSearch(filtrateform)">搜索</el-button>
			</p>
            <el-table
                :data="listHeadPerson"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column prop="cellphoneNumber" label="电话"></el-table-column>
				<el-table-column prop="identityCards" label="身份证号码"></el-table-column>
                <!-- <el-table-column prop="statusStr" label="状态" align="center"></el-table-column> -->
				<el-table-column prop="statusStr" label="状态" align="center">
					<template slot-scope="scope">
						 <span v-if="scope.row.status == 1">
							 在职
						 </span>
						 <span v-else style="color: red;">
							 离职
						 </span>
					</template>
				</el-table-column>
				<el-table-column prop="permanentAddress" label="地址"></el-table-column>
				<el-table-column label="操作" width="100" align="center">
				    <template slot-scope="scope">
						<el-button
						    type="text"
						    icon="el-icon-edit"
						    @click="handlePersonEdit(scope.row)"
						>编辑</el-button>
				        <!-- <el-button
				            type="text"
				            @click="headPersonEquit(scope.row)"
				        >离职</el-button> -->
				    </template>
				</el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<!-- 添加人员 -->
		<el-dialog class="branch-dialog" title="添加总部业务员" :visible.sync="addheadPersonVisible" width="600px">
		    <el-form ref="addHeadPersonForm" :model="addHeadPersonForm" :rules="addBusinessPersonsrules">
				  <el-form-item label="姓名" prop="name">
				      <el-input v-model="addHeadPersonForm.name"></el-input>
				  </el-form-item>
		        <el-form-item label="电话" prop="cellphoneNumber">
		            <el-input v-model="addHeadPersonForm.cellphoneNumber"></el-input>
		        </el-form-item>
				<el-form-item label="地址" prop="areaAddress">
					<el-cascader :options="cityList" :props="optionProps" v-model="addHeadPersonForm.areaAddress" style="width: 100%;"></el-cascader>
					
				</el-form-item>
				<el-form-item prop="detailAddress">
					<el-input v-model="addHeadPersonForm.detailAddress"></el-input>
				</el-form-item>
				
				<el-form-item label="身份证号" prop="identityCards">
				    <el-input v-model="addHeadPersonForm.identityCards"></el-input>
				</el-form-item>
				
				<el-form-item label="状态">
				    <el-radio-group v-model="addHeadPersonForm.status">
				        <el-radio label="1">在职</el-radio>
				        <el-radio label="2">离职</el-radio>
				    </el-radio-group>
				</el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addHeadPersonbtn('addHeadPersonForm')">确 定</el-button>
		        <el-button @click="addheadPersonVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
        <!-- 编辑弹出框 -->
		<el-dialog class="branch-dialog" title="编辑总部业务员" :visible.sync="editheadPersonVisible" width="600px">
		    <el-form ref="editHeadPersonForm" :model="editHeadPersonForm" :rules="addBusinessPersonsrules">
				  <el-form-item label="姓名" prop="name">
				      <el-input v-model="editHeadPersonForm.name"></el-input>
				  </el-form-item>
		        <el-form-item label="电话" prop="cellphoneNumber">
		            <el-input v-model="editHeadPersonForm.cellphoneNumber"></el-input>
		        </el-form-item>
				<el-form-item label="地址" prop="areaAddress">
					<el-cascader :options="cityList" :props="optionProps" v-model="editHeadPersonForm.areaAddress" style="width: 100%;"></el-cascader>
					
				</el-form-item>
				<el-form-item prop="detailAddress">
					<el-input v-model="editHeadPersonForm.detailAddress"></el-input>
				</el-form-item>
				
				<el-form-item label="身份证号" prop="identityCards">
				    <el-input v-model="editHeadPersonForm.identityCards"></el-input>
				</el-form-item>
				
				<el-form-item label="状态">
				    <el-radio-group v-model="editHeadPersonForm.status">
				        <el-radio label="1">在职</el-radio>
				        <el-radio label="2">离职</el-radio>
				    </el-radio-group>
				</el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editHeadPersonbtn('editHeadPersonForm')">确 定</el-button>
		        <el-button @click="editheadPersonVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
        
    </div>
</template>




<script>
import { listProvinceCitys,listHeadBusinessPersons,saveHeadBusinessPerson,getHeadBusinessPerson,updateHeadBusinessPerson,quitHeadBusinessPerson} from '@/api/index';// 导入我们的api接口
export default {
    name: 'headbusinesspersons',
    data() {
		  var validPhone = (rule, value, callback) => {
			  // debugger
		        const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
		        if (!value) {
		          return callback(new Error('电话号码不能为空'))
		        }else if(!Number.isInteger(+value)) {
		            callback(new Error('请输入数字值'))
		        } else {
		            if (phoneReg.test(value)) {
		              callback()
		         } else {
		              callback(new Error('电话号码格式不正确'))
		            }
		          }
		 };
		 var validIdNum = (rule, value, callback) => {
		   const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
		   if (!value) {
		     return callback(new Error('证件号码不能为空'))
		   } else if (!reg.test(value)) {
		     return callback(new Error('证件号码不正确'))
		   } else {
		     callback()
		   }
		 };
		  
        return {
			cityList:[],//省市数据
			optionProps: {
				// TODO
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,
            listHeadPerson: [],  //列表数据
			addHeadPersonForm:{
				name:'',
				cellphoneNumber:'',
				areaAddress: [{
					value: ''
				}],  
				detailAddress:'',  
				identityCards:'',
				status:'1'
			},    //添加表单
			addBusinessPersonsrules: {
				  name:[
					  { required: true, message: '请输入用户名', trigger: 'blur' }
				  ],
				  cellphoneNumber:[
					{ required: true, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
				  ],
				   identityCards:[
				  	{ required: true, trigger: 'blur', validator: validIdNum }
				  ],
				 
				},  //添加表单验证
			
			editHeadPersonForm:{},   //编辑表单
			addheadPersonVisible:false,
			editheadPersonVisible: false,
			
            filtrateform:{
            	name:''
            },  //筛选
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistHeadBusinessPersons();
		//省市
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		});
		
	
		
    },
    methods: {
		// 列表数据
		getlistHeadBusinessPersons(){
			listHeadBusinessPersons({
				current: this.query.pageIndex,                    
				size: this.query.pageSize,
			    name:this.filtrateform.name
			}).then(res => {
				// 获取数据成功后的其他操作
				this.listHeadPerson = res.data.records;
				this.pageTotal = res.data.total;
			});
		},
		// 筛选
		filtrateSearch(form){
			this.query.pageIndex = 1;
			this.filtrateform.name = form.name;
			this.getlistHeadBusinessPersons()
		},
		
		// 添加人员
		addHeadPerson(formName){
			this.addheadPersonVisible = true;
			//重置表单数据
			this.$nextTick(()=>{
			  this.$refs.[formName].resetFields();
			})
		},
		
		// 添加机构分支保存
		addHeadPersonbtn(formName){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  this.addHeadPersonForm.areaAddress = JSON.stringify(this.addHeadPersonForm.areaAddress);
				  saveHeadBusinessPerson(this.addHeadPersonForm).then(res => {
					  this.query.pageIndex = 1;
					  //重置表单数据
					  this.$nextTick(()=>{
					    this.$refs.['filtrateform'].resetFields();
					  })
					  this.filtrateform.name = '';
					  this.getlistHeadBusinessPersons();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.addheadPersonVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
			
			
		},
       
        // 删除操作
        headPersonEquit(row) {
			if(row.status == 1){
				// 二次确认删除
				this.$confirm('确定要修改状态吗？', '提示', {
				    type: 'warning'
				}).then(() => {
					quitHeadBusinessPerson({},{
						 "personId": row.personId          
					}).then(res => {
						this.query.pageIndex = 1;
						this.getlistHeadBusinessPersons();
						if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
						}else if(res.code == 1){
							  this.$message({
								message: res.message,
								type: 'warning'
							  });
						}else{
							  this.$message({
								message: '报错啦!',
								type: 'warning'
							  });
						}
						
					});
				}).catch(() => {});
			}else{
				this.$confirm('已经是离职状态!', '提示', {
				    type: 'warning'
				}).then(() => {
					
				}).catch(() => {});
			}
           
        },
       
        // 点击编辑操作
        handlePersonEdit(row) {
			getHeadBusinessPerson({},{
					 "personId": row.personId,
				}).then(res => {
					this.editHeadPersonForm = res.data;
					if(typeof(this.editHeadPersonForm.areaAddress) == "string"){
						this.editHeadPersonForm.areaAddress = JSON.parse(this.editHeadPersonForm.areaAddress);	
					}
					if(typeof(this.editHeadPersonForm.status) == 'number'){
						this.editHeadPersonForm.status = this.editHeadPersonForm.status+'';	
					}
				});
				
				this.editheadPersonVisible = true;
			
        },
        // 保存编辑
        editHeadPersonbtn(formName) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
            	  // 负责区域字段格式处理
            	  this.editHeadPersonForm.areaAddress = JSON.stringify(this.editHeadPersonForm.areaAddress);
            	  
            	  updateHeadBusinessPerson(this.editHeadPersonForm).then(res => {
            		  this.getlistHeadBusinessPersons();
            		  if(res.code == 0){
            			  // 获取数据成功后的其他操作
            				this.$message({
            				  message: res.message,
            				  type: 'success'
            				});
            				this.editheadPersonVisible = false;
            		  }else if(res.code == 1){
            			  this.$message({
            			    message: res.message,
            			    type: 'warning'
            			  });
            		  }else{
            			  this.$message({
            			    message: '报错啦!',
            			    type: 'warning'
            			  });
            		  }
            		   
            	  });
              } else {
            	return false;
              }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistHeadBusinessPersons();
        }
    }
};
</script>

<style scoped>
	/* 筛选 */
	.filtrate_flex{
		display: flex;
		display: -webkit-flex;
		}
	.filtrate_form{
		width: 300px;
	}
	
	.filtrate_btn{
		width: 100px;
		height: 32px;
	}
	
	
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}




</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	width: 100px;
}
.filtrate_form .el-form-item__label{
		font-size: 16px;
	}
.branch-dialog .el-form-item__content{
	margin-left: 100px;
}
/* .branch-area .el-form-item__content{
	margin-top: 30px;
} */
.branch-area{
	text-align: right;
}
.branch-area i{
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem {
	position: relative;
	margin-top: 10px;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.select-box .el-select {
	width: 100%;
}
</style>
